import { render, staticRenderFns } from "./PropagacaoDaUniTrAtDaCtmt.vue?vue&type=template&id=5bee86dc&"
import script from "./PropagacaoDaUniTrAtDaCtmt.vue?vue&type=script&lang=js&"
export * from "./PropagacaoDaUniTrAtDaCtmt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports